<template lang="pug">
  v-container()
    .display-2 Our Church Community
    v-row(justify="center")
      v-col(cols="12")
        v-card.primary.float-md-right.pa-2.ma-4( width="100%" shaped max-width="576"  )
          <iframe width="100%" height="315" src="https://www.youtube.com/embed/HyWK282efOU?start=4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        p.body-1 The seed for City of Refuge UCC grew from a small group of mostly gay and lesbians Christians’ deep desire to have a worship space that resembled the churches of their youth, but contained none of the toxic theology that was so often present in those spaces. Specifically the group desired a church that would (i) not be adverse to female clergy; (ii) welcome same-gender- loving and transgendered people; (iii) take seriously Jesus’ commitment to social justice; (iv) value and welcome all people regardless of their race or social status; and (v) and be accountable to its members. After a year of intense contemplation, study and prayer, this visionary group founded the City of Refuge in 1991 to live out these ideals.
        p.body-1 The original twenty-seven member church was first located in San Francisco near 14th and Belcher. It was a small open sanctuary that City of Refuge shared with the Central United Methodist Church and quickly outgrew. It wasn’t uncommon in those days for a passerby to hear the music coming from the church, wander into its open doors and be invited to take part in the worship service. The passerby might be a homeless person, a doctor, an ex-convict or a student. Regardless of the person’s station, he or she would be met with the same open arms of City of Refuge members. Although the church moved several more times before arriving at its current location in Oakland, that spirit of radical inclusivity has never left.

        p.body-1 In 1995, City of Refuge was accepted into the United Church of Christ, joining the company of over 5,000 other churches around the world that are dedicated to using their faith to effect a just and sustainable world, not just for Christians, but for all people regardless of their faith. With the support of its members and the UCC, City of Refuge continues to live out the demands of its faith through the various programs that it runs or partners with other organizations that address substance abuse, homelessness, HIV/AIDS and green justice.
    v-row(height="224" no-gutters)
      v-col(cols="12" md="4" 'offset-sm'="8" 'offset-md'="0" )
        v-card( height="100%"  'max-width'="250")
          v-img( src="../../assets/img/8439540.png" height="224"   )
          v-card-title Belcher Street Beginnings
      v-col(cols="12" md="4" 'offset-sm'="4" 'offset-md'="0")
        v-card( height="100%"  'max-width'="250")
          v-img( src="../../assets/img/5136483.jpg" height="224"  )
          v-card-title Visions and Plans
      v-col(cols="12" md="4")
        v-card( height="100%" 'max-width'="250" )
          v-img( src="../../assets/img/3283869.jpg" height="224"  )
          v-card-title New Sanctuary on Enterprise Way
    v-row(justify="center")
      v-col(cols="12")
        CORInterviews
    v-row(justify="center")
      v-col(cols="12")
        v-card.pa-5(color="primary" shaped dark)
          v-row( width="100%")
            v-col.pa-0(cols="12")
              .display-4.quotes() &ldquo;  
          v-row( justify="center" align="start")
            v-col(cols="12")
              .body-1.px-10 I stopped being afraid a long time ago when I realized that negative, angry, unfulfilled people are not in charge of my&nbsp;destiny."
          v-row(width="100%" )
            v-col.pa-0(cols="12" align="end")
              .display-4.quotes() &rdquo;
          v-row(width="100%")
            v-col.py-3(cols="12" align="end")
              .body-1  &mdash; Bishop Yvette Flunder  
</template>

<script>
import CORInterviews from '../../components/media/cor-interviews';
import VueAudio from 'vue-audio';
export default {
  components: {
    CORInterviews
  },
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>

<style lang="stylus">
.v-card__text, .v-card__title
  word-break normal /* maybe !important */

.quotes
  font-family cardo !important
  height 35px
</style>
